import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { ListItem, ListItemText, ListItemIcon } from '@pwc/appkit-react/lib/List';
import { Tooltip } from '@pwc/appkit-react/lib/Tooltip';

import { JobPropType } from '../../shared/jim/propTypes';

const FailedJob = ({
  job,
  openModal,
}) => {
  const openModalWithErrorDetails = useCallback(() => openModal(job.returnedError), [openModal, job]);
  const jobLabel = job.returnedError?.filename || job.displayName || job.jobType;

  return (
    <ListItem>
      <ListItemText>{jobLabel}</ListItemText>
      <ListItemIcon
        className="ml-auto text-danger"
        icon={
          <Tooltip content="Show error details" placement="left" containerid="jobs-tooltip-container">
            <span className="appkiticon icon-error-details" onClick={openModalWithErrorDetails}/>
          </Tooltip>
        }
      />
    </ListItem>
  );
};

FailedJob.propTypes = {
  openModal: PropTypes.func.isRequired,
  job: JobPropType.isRequired,
};

export default FailedJob;
